<app-navbar>
	<button class="btn btn-warning me-2" (click)="print()">
		<i class="fas fa-print"></i>
		Drukuj
	</button>
	<a routerLink="/resident/residentTrips" class="btn btn-danger">
		<i class="fas fa-chevron-left"></i>
		Powrót
	</a>
</app-navbar>

<div class="contatiner my-4">
	<h3>Lista Osób</h3>
	<app-dynamic-table
		module="reservationsPeopleList"
		[elements]="data"
		[tableRows]="tableRows"
		[haveAnyFilters]="false"
		[haveLink]="false"
		[showHeader]="false"
		[rowsPerPage]="9999"
	></app-dynamic-table>
</div>
